import React, { useState } from "react";
import styled from "styled-components";
import { BsClock } from "react-icons/bs";
import DetailsCard2 from "./DetailsCard2";
import { useEffect } from "react";

const FoodCard2 = ({ recipe }) => {
  const [showDetails, setShowDetails] = useState(false);
  const ingredientsList = recipe.ingredientList.split(",");
  useEffect(() => {
    console.log("useEffect");
  }, [showDetails]);
  return (
    <Container>
      <ImageContainer onClick={() => setShowDetails(true)}>
        <img src={recipe.image} alt="" />
      </ImageContainer>
      <ContentContainer>
        <Title>{recipe.recipeName}</Title>
        <Subtitle>
          <PreparationTime>
            <BsClock style={{ marginRight: "4px" }} />
            {recipe.cookTime}
          </PreparationTime>
          <RecipeButton onClick={() => setShowDetails(true)}>
            Kaise banega
          </RecipeButton>
        </Subtitle>
      </ContentContainer>

      {showDetails && (
        <DetailsCard2
          ingredientsList={ingredientsList}
          recipe={recipe}
          setShowDetails={setShowDetails}
        ></DetailsCard2>
      )}
    </Container>
  );
};
const Container = styled.div`
  height: 350px;
  width: 300px;
  border: 1px solid #e8e1e1;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-self: center;
  margin: 20px 0;
`;
const ImageContainer = styled.div`
  height: 60%;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;
const ContentContainer = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;
const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 25px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
  margin: 10px 0;
`;
const Subtitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const PreparationTime = styled.div`
  display: flex;
  align-items: center;
`;
const RecipeButton = styled.button`
  border: none;
  background-color: #f15d53;
  color: #fff;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px; ;
`;

export default FoodCard2;
